import React, { useCallback, useReducer, useEffect } from 'react';
import { StyleSheet, Text } from 'react-native';
import { CalendarList } from 'react-native-calendars';
import { Color, CommonProperties } from '../../../styles';
import { AntDesign } from '@expo/vector-icons';

import { getPoints } from '../../../utils/currency.utils';

export const AACalendar = (props) => {
  const { redeemCalendar, leg, date, onDaySelected, findDayAward } = props;
  const markedDatesInitialState = {
    isFromDatePicked: false,
    isToDatePicked: false,
    markedDates: {},
    fromDate: undefined,
  };
  const [markedDatesState, markedDatesDispatch] = useReducer(
    markedDatesReducer,
    markedDatesInitialState
  );

  function markedDatesReducer(state, action) {
    switch (action.type) {
      case 'set': {
        return action;
      }

      default:
        throw new Error('invalid date action in marked dates reducer');
    }
  }

  const initSelectedDates = () => {
    const startDate = {
      selected: true,
      color: Color.primary,
      textColor: 'white',
      dateString: date,
    };
    const markedDates = { [date]: startDate };
    markedDatesDispatch({ type: 'set', markedDates });
  };
  useEffect(initSelectedDates, []);

  const onDayPress = useCallback(
    (day) => {
      if (!findDayAward(day, leg)) {
        return;
      }
      onDaySelected(day);
      const startDate = {
        selected: true,
        color: Color.primary,
        textColor: 'white',
        dateString: day.dateString,
      };
      const markedDates = { [day.dateString]: startDate };
      markedDatesDispatch({ type: 'set', markedDates });
    },
    [findDayAward, leg, onDaySelected]
  );

  const underDayView = (date) => {
    const NA = 'N.A.';
    const dayAward = findDayAward(date, leg);
    const textPoints = dayAward ? getPoints(dayAward.Points) : NA;

    return (
      <Text
        style={[
          lowFareClassMap.below,
          { color: textPoints === NA ? Color.disabled : Color.primary },
        ]}
      >
        {textPoints}
      </Text>
    );
  };
  return (
    <CalendarList
      pastScrollRange={0}
      futureScrollRange={0}
      hideArrows={false}
      current={date}
      renderArrow={(direction) => <AntDesign color={Color.primary} name={direction} size={22} />}
      showScrollIndicator={false}
      scrollEnabled={true}
      minDate={redeemCalendar.RedeemCalendar[leg].Week[0].Day[0].DisplayDate}
      maxDate={redeemCalendar.RedeemCalendar[leg].Week.at(-1).Day.at(-1).DisplayDate}
      onDayPress={onDayPress}
      markedDates={markedDatesState.markedDates}
      markingType={'period'}
      theme={{
        textDayFontFamily: CommonProperties.fontFamily.fontFamily,
        textMonthFontFamily: CommonProperties.fontFamily.fontFamily,
        textDayHeaderFontFamily: CommonProperties.fontFamily.fontFamily,
      }}
      calendarHeight={310}
      renderUnderDayView={underDayView}
    />
  );
};

const styles = StyleSheet.create({
  performanceTextStyle: {
    ...CommonProperties.fontFamily,
    ...CommonProperties.body,
  },
  performanceTextStyleAboveAvg: {
    ...CommonProperties.fontFamily,
    ...CommonProperties.body,
    color: Color.primary,
  },
  performanceTextStyleBelowAvg: {
    ...CommonProperties.fontFamily,
    ...CommonProperties.body,
    fontSize: 11,
    fontWeight: 'bold',
  },
});

const lowFareClassMap = {
  below: styles.performanceTextStyleBelowAvg,
  equal: styles.performanceTextStyle,
  above: styles.performanceTextStyleAboveAvg,
};
